import { type RefObject, useLayoutEffect, useState } from "react";

const measure = (element: HTMLElement | null): number | null => {
  const viewport = window.visualViewport;
  if (!viewport || !element) return null;
  // 見えている部分の下端（キーボードの上端）を、ページ上の座標に直して、要素の上端との差を取る
  return Math.round(
    viewport.offsetTop + viewport.height - element.getBoundingClientRect().top,
  );
};

/**
 * 要素の上端から、見えている部分の下端（キーボードの上端）までの高さ。
 * iOS ではキーボードを開いても layout viewport は縮まず、ヘッダーの高さも端末で変わるため、
 * 固定値ではなく、`window.visualViewport` と要素の実際の位置から求める。使えなければ null。
 */
export const useVisibleHeightBelow = (
  ref: RefObject<HTMLElement | null>,
): number | null => {
  const [height, setHeight] = useState<number | null>(null);

  useLayoutEffect(() => {
    const viewport = window.visualViewport;
    const update = () => setHeight(measure(ref.current));
    update();
    viewport?.addEventListener("resize", update);
    viewport?.addEventListener("scroll", update);
    return () => {
      viewport?.removeEventListener("resize", update);
      viewport?.removeEventListener("scroll", update);
    };
  }, [ref]);

  return height;
};
